import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { showConfirmModal } from 'actions/global';
import { deleteList } from 'services/recruitment.service';
import DataTable from 'components/shared/DataTable/index';

const RecruitmentTable = ({ data, totalPages, itemsPerPage, page, totalItems, onChangePage, onRefresh }) => {
  const dispatch = useDispatch();
  const columns = useMemo(
    () => [
      {
        header: 'Tiêu đề tuyển dụng',
        accessor: 'recruitment_name',
      },
      {
        header: 'Vị trí',
        accessor: 'position_name',
      },
      {
        header: 'Bệnh viện / Cơ sở',
        accessor: 'business_name',
      },
      {
        header: 'Phòng ban / Chuyên khoa',
        accessor: 'department_name',
      },
      {
        header: 'Ngày ứng tuyển',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        accessor: 'created_date',
      },
      {
        header: 'Trạng thái',
        accessor: 'is_active',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        formatter: (p) =>
          p?.is_active ? (
            <span className='bw_label_outline bw_label_outline_success text-center'>Kích hoạt</span>
          ) : (
            <span className='bw_label_outline bw_label_outline_danger text-center'>Ẩn</span>
          ),
      },
    ],
    [],
  );

  const actions = useMemo(() => {
    return [
      {
        globalAction: true,
        icon: 'fi fi-rr-plus',
        type: 'success',
        content: 'Thêm mới',
        permission: 'CMS_RECRUITMENT_ADD',
        onClick: () => window._$g.rdr(`/recruitment/add`),
      },
      {
        icon: 'fi fi-rr-edit',
        color: 'blue',
        title: 'Sửa',
        permission: 'CMS_RECRUITMENT_EDIT',
        onClick: (p) => window._$g.rdr(`/recruitment/edit/${p?.recruitment_id}`),
      },
      {
        icon: 'fi fi-rr-eye',
        color: 'green',
        title: 'Chi tiết',
        permission: 'CMS_RECRUITMENT_VIEW',
        onClick: (p) => window._$g.rdr(`/recruitment/detail/${p?.recruitment_id}`),
      },
      {
        icon: 'fi fi-rr-trash',
        color: 'red',
        title: 'Xóa',
        permission: 'CMS_RECRUITMENT_DEL',
        onClick: (_, d) =>
          dispatch(
            showConfirmModal(
              ['Bạn có thực sự muốn xóa?', 'Bạn sẽ mất dữ liệu này và các dữ liệu liên quan.'],
              async () => {
                await deleteList([_?.recruitment_id]);
                onRefresh();
              },
            ),
          ),
      },
    ];
  }, [dispatch, onRefresh]);

  return (
    <DataTable
      columns={columns}
      data={data}
      actions={actions}
      totalPages={totalPages}
      itemsPerPage={itemsPerPage}
      page={page}
      totalItems={totalItems}
      onChangePage={onChangePage}
      handleBulkAction={(e) => {
        dispatch(
          showConfirmModal(
            ['Bạn có thực sự muốn xóa?', 'Bạn sẽ mất dữ liệu này và các dữ liệu liên quan.'],
            async () => {
              await deleteList(e?.map((_) => _?.recruitment_id));
              onRefresh();
            },
          ),
        );
      }}
    />
  );
};

export default RecruitmentTable;
